import { WithSplitioNamespace } from '../state/splitio';
import {
    ENABLE_APPLE_PAY,
    ENABLE_GOOGLE_PAY,
    ENABLE_INTERSTITIAL_STEP,
    ENABLE_NOS_DEMO,
} from '../utils/splitio';

export const getSplitTreatmentValue = (
    state: WithSplitioNamespace,
    splitName: string,
): string => {
    const treatments = state.splitio?.treatments;
    return (
        (treatments &&
            treatments[splitName] &&
            Object.values(treatments[splitName])?.[0]?.treatment) ??
        'off'
    );
};

export const isSplitTreatmentEnabled = (
    state: WithSplitioNamespace,
    splitName: string,
) => getSplitTreatmentValue(state, splitName) === 'on';

export const isApplePaySplitTreatmentEnabled = (state: WithSplitioNamespace) =>
    isSplitTreatmentEnabled(state, ENABLE_APPLE_PAY);

export const isGooglePaySplitTreatmentEnabled = (state: WithSplitioNamespace) =>
    isSplitTreatmentEnabled(state, ENABLE_GOOGLE_PAY);

export const isLoginInterstitialSplitTreatmentEnabled = (
    state: WithSplitioNamespace,
) => isSplitTreatmentEnabled(state, ENABLE_INTERSTITIAL_STEP);

export const isNosDemoEnabled = (state: WithSplitioNamespace) =>
    isSplitTreatmentEnabled(state, ENABLE_NOS_DEMO);
